import React, { useState } from "react";
import { connect } from "react-redux";
import TimeInput from "react-input-time";
import { createSession } from "../../store/playList/actions";
import Iframe from 'react-iframe';

const Createsession = (props) => {
  const [state, setState] = useState({
    title: "",
    date: "",
    noofParticipants: "",
    price: "",
    time: `${new Date().getHours()}:${new Date().getMinutes()}`,
    loading: false,
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setState({
      ...state,
      [name]: value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { playlistId } = props?.location?.state;
    const { title, date, noofParticipants, price, time } = state;
    if (!playlistId) return;
    await props.createSession({
      title,
      date,
      noofParticipants,
      price,
      time,
      playlistId,
    });
    setState({
      title: "",
      date: "",
      noofParticipants: "",
      price: "",
      time: `${new Date().getHours()}:${new Date().getMinutes()}`,
      loading: false,
    });
  };

  const maxDate = () => {
    let dtToday = new Date();
    let month = dtToday.getMonth() + 1;
    let day = dtToday.getDate();
    let year = dtToday.getFullYear();
    if (month < 10) month = "0" + month.toString();
    if (day < 10) day = "0" + day.toString();

    let maxDate = year + "-" + month + "-" + day;
    return maxDate;
  };

  return (
    <div className="Profile container ">
      <h1 className=" font-weight-bold text-black-50 mb-5 pb-3 border-bottom w-100 text-left">
        Create Session
      </h1>
      <div className="card shadow ">
        <form action="" onSubmit={handleSubmit}>
          <div className="row top h-100 ">
            <div className="col-12 col-md-12">
              <div className="input-wrapper">
                <div className="input-top">
                  <label htmlFor="" className="input-top-label">
                    Session Name*
                  </label>
                </div>
                <input
                  type="text"
                  className="input form-control"
                  placeholder="e.g. First session"
                  required
                  name="title"
                  value={state.title}
                  onChange={(e) => handleChange(e)}
                />
              </div>
              <div className="input-wrapper">
                <div className="input-top">
                  <label htmlFor="" className="input-top-label">
                    Date*
                  </label>
                </div>
                <input
                  type="date"
                  className="input form-control"
                  required
                  name="date"
                  value={state.date}
                  min={maxDate()}
                  onChange={(e) => handleChange(e)}
                />
              </div>
              <div className="input-wrapper">
                <div className="input-top">
                  <label htmlFor="" className="input-top-label">
                    Time*
                  </label>
                </div>
                <TimeInput
                  className="input form-control"
                  initialTime={`${new Date().getHours()}:${new Date().getMinutes()}`}
                  value={state.time}
                  onChange={(e) => handleChange(e)}
                />
              </div>
              <div className="input-wrapper">
                <div className="input-top">
                  <label htmlFor="" className="input-top-label">
                    Total Participants*
                  </label>
                </div>
                <input
                  type="number"
                  className="input form-control"
                  placeholder="e.g. 10"
                  name="noofParticipants"
                  required
                  value={state.noofParticipants}
                  onChange={(e) => handleChange(e)}
                />
              </div>
              <div className="input-wrapper">
                <div className="input-top">
                  <label htmlFor="" className="input-top-label">
                    Price*
                  </label>
                </div>
                <input
                  type="number"
                  className="input form-control"
                  required
                  name="price"
                  value={state.price}
                  placeholder="e.g. $100"
                  onChange={(e) => handleChange(e)}
                />
              </div>
              <div className="input-wrapper d-flex">
                <button className="btn" type="submit" disabled={state.loading}>
                  {state.loading ? "..." : "Submit"}
                </button>
              </div>
              {props?.playlist?.newSession?.streamKey && (
                <div>
                  Start your live stream. Stream Key:{" "}
                  {props?.playlist?.newSession?.streamKey}{" "}
                  Url: {"rtmp://broadcast.api.video/s"}
                </div>
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  playlist: state.playlist,
});

export default connect(mapStateToProps, {
  createSession,
})(Createsession);
